<template>
  <span class="text-red-2 dark:text-dark-red">*</span>
</template>
